import {
    UPDATE_SEARCH_KEYWORD,
    SUBMIT_SEARCH_BY_ENTER 
} from '../actions';

export const updateSearchKeyword = (keyword) => {
  return {
    type: UPDATE_SEARCH_KEYWORD,
    payload: keyword, // Dữ liệu từ input sẽ nằm ở đây
  };
};

// Action mới không cần payload, nó chỉ là một tín hiệu
export const submitSearchByEnter = () => ({
  type: SUBMIT_SEARCH_BY_ENTER,
});